/**
 * AKU stats overview cards. The "Zur Prüfung" card toggles a DRAFT filter
 * via the parent's filterStatus state.
 */
import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { Play, FileText, AlertTriangle, ShieldCheck } from 'lucide-react';

const AkuStatsOverview = ({ stats, filterStatus, onFilterStatusChange }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      <Card>
        <CardContent className="pt-4">
          <div className="text-2xl font-bold">{stats.total}</div>
          <div className="text-sm text-gray-600">Gesamt</div>
        </CardContent>
      </Card>

      <Card className="border-green-200">
        <CardContent className="pt-4">
          <div className="text-2xl font-bold text-green-700">
            {stats.ready_for_generation || 0}
          </div>
          <div className="text-sm text-green-600 flex items-center gap-1">
            <Play className="w-4 h-4" />
            Generierungsbereit
          </div>
        </CardContent>
      </Card>

      <Card
        className={`cursor-pointer border-2 ${filterStatus === 'DRAFT' ? 'border-blue-500' : 'border-transparent'}`}
        onClick={() => onFilterStatusChange(filterStatus === 'DRAFT' ? '' : 'DRAFT')}
        data-testid="aku-stats-needs-review"
      >
        <CardContent className="pt-4">
          <div className="text-2xl font-bold text-blue-700">{stats.needs_review || 0}</div>
          <div className="text-sm text-blue-600 flex items-center gap-1">
            <FileText className="w-4 h-4" />
            Zur Prüfung
          </div>
        </CardContent>
      </Card>

      <Card className="border-red-200">
        <CardContent className="pt-4">
          <div className="text-2xl font-bold text-red-700">{stats.blocked || 0}</div>
          <div className="text-sm text-red-600 flex items-center gap-1">
            <AlertTriangle className="w-4 h-4" />
            Blockiert
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-4">
          <div className="text-2xl font-bold text-purple-700">
            {stats.by_normative_status?.SUPPORTED_PRIMARY || 0}
          </div>
          <div className="text-sm text-purple-600 flex items-center gap-1">
            <ShieldCheck className="w-4 h-4" />
            PRIMARY
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AkuStatsOverview;
